// extracted by mini-css-extract-plugin
export default {"printFOIA":"PrintFOIA-module__printFOIA--BTPGR","printReview":"PrintFOIA-module__printReview--B0oNf"};